import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { DbCommon } from "src/app/constants/dbCommon";
import { TableColumnType } from "src/app/constants/table";
import { FileExtended } from "src/app/models/file-extended";
import { TableColumn } from "src/app/models/table";
import { FileService } from "src/app/services/file.service";

@Component({
    selector: 'mwp-file-upload',
    templateUrl: './file-upload.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FileUploadComponent {
    @Input() public buttonName: string = 'Browse Files';
    @Input() public isButtonDisabled: boolean = false;
    @Input() public displayFileSizeText: boolean = true;
    @Input() public isModal: boolean;
    @Output() public filesEmit: EventEmitter<File[]> = new EventEmitter();

    public isValid: boolean;
    public fileListArray: File[] = [];
    public fileExtended: FileExtended[];
    public uploadErrorMessage: string;
    public totalSize: string = '0 KB';
    public isOutOfDownloadRange: boolean;
    public totalFileSize: number = 0;

    public filesMatTableData: MatTableDataSource<FileExtended>;
    public filesColumns: TableColumn[] = [

    ];

    constructor(
        private fileService: FileService,
    ) {
    }

    ngOnInit(): void {
        this.filesColumns = [
            {
                columnName: 'File Name',
                propertyId: 'file.name',
                columnType: TableColumnType.label,
                width: this.isModal ? '40%' : '60%',
            },
            {
                columnName: 'Size',
                propertyId: 'convertedFileSize',
                columnType: TableColumnType.label,
                width: this.isModal ? '' : '20%',
            },
            {
                columnName: 'Delete',
                propertyId: 'id',
                columnType: TableColumnType.button,
                dataTypeText: 'Delete',
                cssCustomClass: 'mwp-button-delete ignore-min-width ',
                width: this.isModal ? '' : '20%',
            },
        ];
    }

    public uploadDocuments(event: any): void {
        const l_EventFiles = this.fileService.selectMultipleEvent(event.target.files);
        l_EventFiles.map((ef: File) => {
            this.fileListArray.push(ef);
        });
        this.emitDocuments();
        // Need to set the target files to null to reset trigger or selecting the same file again will not be added to list.
        event.target.value = null;
    }

    public deleteDocument(requestFile: FileExtended): void {
        const index = this.fileListArray.indexOf(requestFile.file, 0);
        if (index > -1) {
            this.fileListArray.splice(index, 1);
            this.emitDocuments();
        }
    }

    private emitDocuments(): void {
        let l_DummyId: number = 0;
        const l_FileExtendedArray: FileExtended[] = [];
        this.totalFileSize = 0;
        this.fileListArray.map((fla: File) => {
            const l_FileExtended = new FileExtended();
            l_FileExtended.file = fla;
            l_FileExtended.id = l_DummyId;
            l_FileExtended.convertedFileSize = this.fileService.convertFileSizeToString(fla.size);
            l_FileExtendedArray.push(l_FileExtended);
            this.totalFileSize += fla.size;
            l_DummyId++;
        });
        this.filesMatTableData = new MatTableDataSource<FileExtended>();
        this.filesMatTableData.data = l_FileExtendedArray;

        this.uploadErrorMessage = this.fileService.checkFileLoadErrors();
        this.totalSize = this.fileService.convertFileSizeToString(this.totalFileSize);
        this.isOutOfDownloadRange = this.totalFileSize > DbCommon.maxFileUploadSize;
        this.isValid = !this.uploadErrorMessage;
        if (this.isValid)
            this.filesEmit.emit(this.fileListArray);
    }
}